import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';

@Component({
  selector: 'app-common-timer-email',
  templateUrl: './common-timer-email.component.html',
  styleUrls: ['../parts.css']
})
export class CommonTimerEmailComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 日期列
  dateDisplayText = '日期';
  datePopVisible = false;
  dateColumnList = [];

  // 条件 WHEN
  whenComponentDisplayText = '何时'; // When组件默认文字
  whenConditionPopVisible = false; // When组件POP显示
  whenComponentData: any; // when组件接收存放数据

  mailPopVisible = false;
  receiverPopVisible = false;
  smsPattern = 'custom';
  smsTemplateList;
  notificationData: any; // 存放通知组件数据

  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID

  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    dueDateColumn: '',
    email: null,
    siteMessage: null,
    sms: null,
    receiver: {
    },
    dateTrigger: {},
    conditions: [{}],
    instanceDescription: ''
  }; // 存放入参数据
  @ViewChild('pulseIntegration') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      if (this.boardColumnData && this.boardColumnData.length > 0) {
        for (const column of this.boardColumnData) {
          if (column.type === 'date') {
            this.dateColumnList.push(column);
          }
        }
      }
    }
    // 初始化自动化数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.whenComponentData = this.instanceData.config.dateTrigger;
      this.whenComponentDisplayText = this.whenComponentData ? this.whenComponentData.description : '何时';
      for (const item of this.dateColumnList) {
        if (item.id === this.automation.dueDateColumn) {
          this.dateDisplayText = item.title;
          break;
        }
      }
      this.notificationData = this.instanceData.config.email || this.instanceData.config.siteMessage || this.instanceData.config.sms;
    }
    if (this.smsPattern === 'template') {
      this.taskService.querySmsTemplateList().subscribe(res => {
        this.smsTemplateList = res;
        if (this.smsTemplateList && this.smsTemplateList.length > 0) {
          for (const template of this.smsTemplateList) {
            template['content'] = JSON.parse(template['content']);
          }
        }
      });
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  dateSelectChange(item) {
    this.dateDisplayText = item.title;
    this.automation.dueDateColumn = item.id;
    this.datePopVisible = false;
    this.packageData();
  }

  getWhenComponentData(data) {
    this.automation.dateTrigger = data.dateTrigger;
    this.whenComponentData = data;
    this.whenComponentDisplayText = data.dateTrigger.description;
    this.packageData();
  }

  closeWhenPop() {
    this.whenConditionPopVisible = false;
  }

  getNotificationData(data) {
    this.notificationData = data.content;
    if (data.type === 'email') {
      this.automation.email = data.content;
      this.automation.siteMessage = null;
      this.automation.sms = null;
    } else if (data.type === 'siteMessage') {
      this.automation.siteMessage = data.content;
      this.automation.email = null;
      this.automation.sms = null;
    } else {
      this.automation.sms = data.content;
      this.automation.email = null;
      this.automation.siteMessage = null;
    }
    this.mailPopVisible = false;
  }

  getUserData(data) {
    this.automation.receiver = data;
    this.packageData();
  }

  packageData() {
    const text = this.whenComponentDisplayText ? `${this.whenComponentDisplayText.slice(0, 24)}...` : this.whenComponentDisplayText;
    this.automation.instanceDescription = '当 ' + this.dateDisplayText + ' 至 ' + text + ' ， 发 通知 给 客户';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.automation.dueDateColumn &&
      JSON.stringify(this.automation.dateTrigger) !== '{}' &&
      (this.automation.email || this.automation.siteMessage || this.automation.sms) &&
      (this.automation.receiver && this.automation.receiver['value'] && this.automation.receiver['value'].length > 0);
  }
}
